var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{staticClass:"layout__auth flex-center-full",class:'theme-' + _vm.$store.state.layout.theme},[_c('v-main',[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }